import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import SiteActivation, {
    ExistingUser
} from "@/components/signup/site-activation";
import { SitePicker } from "@/components/signup/site-activation/components/common/site-picker";
import { getFirstName } from "@/components/signup/utils";
import { useUserContext } from "@/components/user-context";

import {
    InputEmail,
    NoCreditCardRequired,
    SubmitButtonExistingUser
} from "../../components";

import { BlueWaveTemplateJsm } from "./";

export const LoggedInBlueWaveTemplateJsmExistingUser = ({
    productEditionText
}: {
    productEditionText: string;
}) => {
    const { formatMessage } = useIntl();
    const {
        user: { name, email }
    } = useUserContext();

    return (
        <BlueWaveTemplateJsm productEditionText={productEditionText}>
            <div css={containerCss}>
                <h2 css={siteActivationHeadingCss}>
                    {name
                        ? formatMessage(
                              {
                                  id: "BxpUiSignup.nameSite.header",
                                  defaultMessage: "Welcome back, {name}"
                              },
                              { name: getFirstName(name) }
                          )
                        : formatMessage({
                              id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                              defaultMessage: "Welcome back"
                          })}
                </h2>
                <InputEmail email={email} />
                <SiteActivation
                    ExistingUser={
                        <ExistingUser
                            SubmitButton={<SubmitButtonExistingUser />}
                            SitePicker={
                                <div css={sitePickerCss}>
                                    <SitePicker />
                                </div>
                            }
                        />
                    }
                    ManagedUser={null}
                    WeekOneUser={null}
                />
                <div css={spacingSyles}>
                    <NoCreditCardRequired />
                </div>
            </div>
        </BlueWaveTemplateJsm>
    );
};

const containerCss = css({
    display: "grid",
    gap: "16px"
});

const siteActivationHeadingCss = css({
    fontSize: 24,
    fontWeight: 500,
    margin: 0,
    textAlign: "center"
});

const sitePickerCss = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["label + div > div:first-of-type"]: {
        borderRadius: "3px !important",
        // eslint-disable-next-line local/ensure-wac-token-usage
        border: "2px solid rgb(179, 186, 197) !important"
    }
});

const spacingSyles = css({
    marginBlockStart: "12px",
    marginBlockEnd: "24px",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["p"]: {
        margin: "12px 0 0"
    }
});
